import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClaimsInsightsContainerComponent } from './claims-insights-container/claims-insights-container.component';
import { ClaimInsightsReportComponent } from './claim-insights-report/claim-insights-report.component';
import { ClaimsDashboardComponent } from '../claims-dashboard/claims-dashboard.component';

const routes: Routes = [
    { path: '', component: ClaimsInsightsContainerComponent, data: {breadcrumb: 'Insights' },
    children: [
      
      { path: 'report', component: ClaimInsightsReportComponent, data: {breadcrumb: 'Report' } },
      { path: 'claims', component: ClaimsDashboardComponent, data: {breadcrumb: 'Claims' } },
      { path: '', redirectTo: 'report', pathMatch: 'full' }
    ]
  }
]
@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
  
})
export class ClaimInsightsRoutingModule { }
